import { start } from './PublicApp';
import { isIbPricingPreviewRoot } from './constants/routes';
import { getPublicPagePath } from './utils/getPublicPagePath';
const rootUrl = getPublicPagePath();
const startPromise = isIbPricingPreviewRoot(rootUrl) ? import( /* webpackChunkName: "ib-pricing" */'./pages/ib-pricing/IbPricingPreviewPage').then(({
  default: IbPricingPreviewPage
}) => start(rootUrl, {
  Routes: IbPricingPreviewPage,
  shouldRedirectNonProxied: false
})) : start(rootUrl);
startPromise.catch(() => {});